import { Col, Form, InputNumber, Row, Select } from "antd";
import { Rules } from "../../core/Rules";
import { getConstantValue, getDateString } from "../../core/helper/UtilHelper";
import moment from "moment";

export const getAnimalPriceCPColumns = (monthState: any[]) => {
  return [
    {
      title: "No",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Ay",
      dataIndex: "month",
      key: "month",
      render: (value: any) => getConstantValue(value, monthState),
      filters: monthState,
      // eslint-disable-next-line
      onFilter: (value: any, record: any) => record.month == value,
    },
    {
      title: "Yıl",
      dataIndex: "year",
      key: "year",
      filters: [
        { text: "2026", value: "2026" },
        { text: "2027", value: "2027" },
        { text: "2028", value: "2028" },
        { text: "2029", value: "2029" },
        { text: "2030", value: "2030" },
      ],
      // eslint-disable-next-line
      onFilter: (value: any, record: any) => record.year == value,
    },
    {
      title: "Oluşturulma Tarihi",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (value: any) => getDateString(value),
      sorter: {
        compare: (a: any, b: any) =>
          moment(a.createdAt).unix() - moment(b.createdAt).unix(),
      },
    },
    {
      title: "Son Güncelleme Tarihi",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (value: any) => getDateString(value),
      sorter: {
        compare: (a: any, b: any) =>
          moment(a.updatedAt).unix() - moment(b.updatedAt).unix(),
      },
    },
  ];
};

export const getAnimalPriceCPFormItems = () => {
  const currentDate = new Date();
  const animalLabels = {
    pregnant: "SAĞMAL GEBE HAYVAN",
    seminated: "SAĞMAL TOHUMLU HAYVAN",
    nonPregnant: "SAĞMAL BOŞ HAYVAN",
    fresh: "FRESH HAYVAN SAYISI",
    dry: "ERKEN KURU",
    closeup: "CLOSEUP (SON 21)",
    fcalf: "DİŞİ BUZAĞI",
    mcalf: "ERKEK BUZAĞI",
    msteer: "ERKEK DANA",
    msteer2: "ERKEK DANA 2",
    msteer3: "ERKEK DANA 3",
    bull: "BOĞA",
    bull2: "BOĞA 2",
    bull3: "BOĞA 3",
    bull4: "BOĞA 4",
    bull5: "BOĞA 5",
    bull6: "BOĞA 6",
    bull7: "BOĞA 7",
    pheifer: "GEBE DÜVE",
    sheifer: "TOHUMLU DÜVE",
    heifer: "BOĞAALTI DÜVE",
    fsteer: "DİŞİ DANA",
  } as any;

  return (
    <>
      <Form.Item
        label="Ay"
        name="month"
        rules={[{ required: true, message: "Ay bilgisi boş bırakılamaz." }]}
        initialValue={(currentDate.getMonth() + 1).toString()}
      >
        <Select
          placeholder="Ay Seçiniz"
          options={[
            { label: "Ocak", value: "1" },
            { label: "Şubat", value: "2" },
            { label: "Mart", value: "3" },
            { label: "Nisan", value: "4" },
            { label: "Mayıs", value: "5" },
            { label: "Haziran", value: "6" },
            { label: "Temmuz", value: "7" },
            { label: "Ağustos", value: "8" },
            { label: "Eylül", value: "9" },
            { label: "Ekim", value: "10" },
            { label: "Kasım", value: "11" },
            { label: "Aralık", value: "12" },
          ]}
        />
      </Form.Item>
      <Form.Item
        label="Yıl"
        name="year"
        rules={[{ required: true, message: "Yıl bilgisi boş bırakılamaz." }]}
        initialValue={currentDate.getFullYear().toString()}
      >
        <Select
          placeholder="Yıl Seçiniz"
          options={[
            { label: "2026", value: "2026" },
            { label: "2027", value: "2027" },
            { label: "2028", value: "2028" },
            { label: "2029", value: "2029" },
            { label: "2030", value: "2030" },
          ]}
        />
      </Form.Item>
      <Row gutter={16} align="middle">
        {Object.keys(animalLabels).map((key) => (
          <Col key={key} span={12}>
            <Form.Item
              name={key}
              label={animalLabels[key]}
              rules={[Rules.required]}
              initialValue="0"
            >
              <InputNumber style={{ width: "100%" }} precision={2} min={0} />
            </Form.Item>
          </Col>
        ))}
      </Row>
    </>
  );
};
